import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

// ================= THUNK =================
export const fetchUsersByCategory = createAsyncThunk(
  "users/fetchUsersByCategory",
  async (category, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/business/searchBusinessUsers`,
      );

      const allUsers = response.data?.users || [];

      // ================= FILTER =================
      const filteredUsers = allUsers.filter((user) => {
        const match = user.categoryPath?.some(
          (path) => path.toLowerCase() === category.toLowerCase(),
        );

        return match;
      });

      return {
        filteredUsers,
        categoryCount: filteredUsers.length,
      };
    } catch (err) {
      console.error("❌ API ERROR:", err);

      return rejectWithValue(err.response?.data || "Error fetching users");
    }
  },
);

// ================= SLICE =================
const userSlice = createSlice({
  name: "users",
  initialState: {
    registeredUsers: [],
    categoryCount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersByCategory.pending, (state) => {
        
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsersByCategory.fulfilled, (state, action) => {
       

        state.loading = false;
        state.registeredUsers = action.payload.filteredUsers;
        state.categoryCount = action.payload.categoryCount;
      })
      .addCase(fetchUsersByCategory.rejected, (state, action) => {
        console.log("❌ Failed:", action.payload);

        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default userSlice.reducer;
